module.exports = __webpack_public_path__ + "static/media/tablet-InDepth.d359a0dd.png";